<template>
<div class="pagewide moderation mtpage">

	<topheader back="/panel">
		<template v-slot:info>
			<span>{{$t('labels.moderation')}}</span>
		</template>
		<template v-slot:right>
			
		</template>

	</topheader>

	<maincontent>
		<template v-slot:content>
            <moderation />
		</template>
	</maincontent>


</div>
</template>

<style lang="sass" scoped>
	

</style>

<script>


export default {
	name: 'panel_moderation_page',
	components: {
		moderation : () => import("@/components/modules/panel/moderation/index.vue")
	},

	data : function(){
		return { 
			searchEnabled : false
		}
	},

	computed: {

	},

	methods: {
		
	},

	mounted() {

	}
}
</script>
